import { Skeleton } from "primereact/skeleton";
import { SplitButton } from "primereact/splitbutton";
import { useCertificateActions } from "sj-ui-toolkit/src/hooks";
import type { PassedBelt } from "sj-ui-toolkit/src/api/user";

interface DownloadCertificateColumnProps {
  rowData: PassedBelt;
  loading: boolean;
  certificateName: string;
  onOpenName: () => void;
}

export function DownloadCertificateColumn({
  rowData,
  loading,
  certificateName,
  onOpenName,
}: DownloadCertificateColumnProps) {
  const {
    viewCertificate,
    copyCertificateLink,
    sendCertificateEmail,
    onOpenLink,
    handleCertificateDownload,
    isDownloading,
  } = useCertificateActions();

  if (loading) return <Skeleton />;

  const menuItems = [
    {
      label: certificateName,
      icon: "pi pi-file",
      command: onOpenName,
    },
    { label: "View Certificate", icon: "pi pi-eye", command: () => viewCertificate(rowData) },
    {
      label: "Copy Certificate link",
      icon: "pi pi-copy",
      command: () => copyCertificateLink(rowData),
    },
    {
      label: "Share on LinkedIn",
      icon: "pi pi-linkedin",
      command: onOpenLink(rowData.linkedinUrl),
    },
    { label: "Share on X", icon: "pi pi-twitter", command: onOpenLink(rowData.twitterUrl) },
    {
      label: "Send me a copy via Email",
      icon: "pi pi-envelope",
      command: () => sendCertificateEmail(rowData),
    },
  ];

  return (
    <SplitButton
      model={menuItems}
      label="Download"
      buttonProps={{
        "aria-label": isDownloading
          ? `Downloading ${rowData.name} certificate`
          : `Download ${rowData.name} certificate`,
        "data-testid": `certificate-download-${rowData.id}-button`,
      }}
      menuButtonProps={{
        "aria-label": "Open certificate options",
        "data-testid": `certificate-download-${rowData.id}-menu-button`,
      }}
      disabled={isDownloading}
      loading={isDownloading}
      icon="pi pi-download"
      onClick={() => handleCertificateDownload(rowData.roleId)}
      menuStyle={{ minWidth: "max-content" }}
    />
  );
}
